import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { v4 } from 'uuid';
import { AttachmentView } from '../../../attachments/attachment-view.model';
import { Attachment } from '../../../attachments/attachment.model';
import { DIALOG_TYPE as attachmentViewDialog } from '../../../attachments/components/attachment-view-dialog/attachment-view-dialog.component';
import { DialogService } from '../../../dialog/dialog.service';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingInputTypeValuesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-attachments-list-item',
  templateUrl: './attachments-list-item.component.html',
  styleUrls: ['./attachments-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsListItemComponent implements OnInit, OnDestroy {
  @Input() attachmentView: AttachmentView;
  @Input() documentType: DocumentTypesEnum;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingObject: ITrackingObject;

  @Output()
  onDeleteAttachmentItem: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();
  @Output()
  onUpdateAttachmentItem: EventEmitter<AttachmentView> = new EventEmitter<AttachmentView>();
  @Output() onEditMode: EventEmitter<boolean> = new EventEmitter<boolean>();

  dialogId: string;
  isEditing: boolean;
  attachmentTapped: ITrackingAction;
  attachmentDeleted: ITrackingAction;
  attachmentDialogName: TrackingDialogNamesEnum;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _dialogService: DialogService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogId = v4();

    const inputId = this.attachmentView.id;
    const inputType = TrackingInputTypeValuesEnum.attachment;
    const docType = this.documentType;

    this.attachmentTapped = this._trackingActionBuilder.buildInputTapped(
      inputId,
      null,
      inputType,
      this.trackingScreenName
    );
    this.attachmentDeleted = this._trackingActionBuilder.buildButtonTapped(
      'delete_photo',
      this.trackingScreenName
    );

    if (docType) {
      this.attachmentDialogName = `${docType}_attachment_fullscreen` as any;
    }
  }

  toggleForm(flag) {
    this.isEditing = flag;
    this.onEditMode.emit(flag);

    this._changeDetectorRef.markForCheck();
  }

  onUpdateAttachment(attachment: Attachment) {
    this.toggleForm(false);
    this.onUpdateAttachmentItem.emit(
      this.attachmentView.setAttachment(attachment)
    );
  }

  onDelete() {
    this.toggleForm(false);
    this.onDeleteAttachmentItem.emit(this.attachmentView);
  }

  onViewAttachment() {
    this._dialogService.openDialog({
      type: `${attachmentViewDialog}-${this.dialogId}`,
    });
  }

  ngOnDestroy() {
    this._dialogService.closeDialog({
      type: `${attachmentViewDialog}-${this.dialogId}`,
    });
  }
}
